import { ListHeader, ListHeaderProps } from 'containers/Header'
import React from 'react'
import { BreadCrumbType } from 'utils/useBreadcrumb'
import { LayoutListChildWrapper, LayoutListWrapper } from '../Common.style'

type ListComponent = React.FC<React.PropsWithChildren<ListProps>>

type ListProps = {
  breadcrumbs?: BreadCrumbType[]
  noPadding?: boolean
} & ListHeaderProps

export const List: ListComponent = ({
  children,
  breadcrumbs,
  onTabChange,
  tabs,
  selectedIndex,
  noTitle,
  customTitle,
  extra,
  noPadding = false,
}) => {
  return (
    <LayoutListWrapper directionColumn="zero">
      <ListHeader
        tabs={tabs}
        onTabChange={onTabChange}
        breadcrumbs={breadcrumbs}
        selectedIndex={selectedIndex}
        noTitle={noTitle}
        customTitle={customTitle}
        extra={extra}
      />
      <LayoutListChildWrapper no-padding={noPadding}>{children}</LayoutListChildWrapper>
    </LayoutListWrapper>
  )
}
